import { PeriodSelect } from './PeriodSelect';

export const EmptyState = () => {
  return (
    <div className="relative grid gap-4 p-x2 lg:px-x3 lg:py-x2">
      <div className="grid grid-cols-2">
        <div className="grid grid-cols-[max-content_max-content] gap-9">
          <div className="grid gap-0.5">
            <p className="mb-0 mt-1 h-5 text-xs text-soft">Portfolio</p>
            <p className="mb-0 text-xs text-soft">n/a</p>
          </div>
          <div className="grid gap-0.5">
            <p className="mb-0 mt-1 h-5 text-xs text-soft">US Market</p>
            <p className="mb-0 text-xs text-soft">n/a</p>
          </div>
        </div>
        <PeriodSelect period="1Y" />
      </div>
      <div className="grid grid-rows-[200px]">
        <div className="grid place-content-center gap-x0_5 bg-p-white-100/10">
          <p className="m-0 text-center text-xs text-solid">
            No data currently available
          </p>
          <p className="m-0 text-center text-tiny text-solid opacity-50">
            Please try again later
          </p>
        </div>
      </div>
    </div>
  );
};
